module.exports = __webpack_public_path__ + "static/guarantee-704c3982da9012463444dc1dd3aaccd1.png";